import Basic from '@/components/page/Basic.js'
import { Rainbow, AxiosWithJar,Config } from '@/utility.js'

export default{
	extends: Basic,
	data:()=>({
		invoice: {overdue: {chart:[], comp:[]}},
		loading: { table:true },
	}),
    methods:{
	
		async loadInvoice() {
			let cnt = 8;
			let url = Config().apiURL + "/vendor/overdue?count=" + cnt
			await AxiosWithJar().get(url).then(result => {
				//console.log(result.data);
				if (result.data.overdue.length) {
					this.invoice.overdue = {
						chart: this.processBarChart(result.data.overdue, "DT", "", "Cnt", false, "", "INVOICE", 1, 2, Rainbow),
						comp: this.createComp(result.data.overdue, "DT", "Cnt", cnt - 1, cnt - 2),
					};
					//console.log(this.invoice.overdue);
				}
			})
		},
		async loadAbsenTkjp(){
			let url =Config().apiURL+"/vendor/absentkjp?"(this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.absen.tkjp = result.data.data[0].Cnt;
				}
			})
		},
	
	},
}